import { Button } from '@arcadiapower/shrike';
import { Title, Description } from '~/components/typography';
import { useCopy } from '~/hooks';
import { SolarFunnelContext } from '~/machines/solar-funnel';
import { Wrapper } from '../errors/error.util';

export const EnergywellPaymentVerificationFailed = ({
  context,
  overrideCopy,
  next,
}: EnergywellPaymentVerificationFailedProps) => {
  const copy = useCopy(context, checkCopy, overrideCopy);

  return (
    <Wrapper testId="screen-PaymentVerificationFailed">
      <Title textAlign="center" marginTop="48px">
        {copy.title}
      </Title>
      <div style={{ width: '353px', marginLeft: 'auto', marginRight: 'auto' }}>
        <Description textAlign="center" marginTop="24px">
          {copy.description}
        </Description>
      </div>
      <Button mode="primary" onClick={next}>
        {copy.buttonText}
      </Button>
    </Wrapper>
  );
};

export const checkCopy = () => {
  return defaultCopy();
};

export interface EnergywellPaymentVerificationFailedProps {
  context: SolarFunnelContext;
  overrideCopy?: (context: any) => Partial<EnergywellPaymentVerificationFailedCopy>;
  next: () => void;
}

export const defaultCopy = () => ({
  title: 'Payment verification failed',
  description: 'It looks like there was an issue verifying your payment.',
  buttonText: 'Continue',
});

export type EnergywellPaymentVerificationFailedCopy = ReturnType<typeof defaultCopy>;
